/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Kpi_Total_OrdersInputs */

const vi_report_kpi_total_orders = /** @type {(inputs: Report_Kpi_Total_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng đơn hàng`)
};

/**

* @param {Report_Kpi_Total_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_kpi_total_orders = /** @type {((inputs?: Report_Kpi_Total_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Kpi_Total_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_kpi_total_orders(inputs)
});